<ng-container *ngIf="action$ | async as action">
  <div [pTooltip]="action.tooltip || action.description" tooltipPosition="top" style="display: inline-block;">
    <p-button [icon]="'pi ' + (action.icon ? 'pi-' + action.icon : 'pi-hidden')"
      [ngClass]="action.name + ' hide-label-responsive'" [label]="action.description" ntapDebounceClick
      (onClick)="executeAction($event)" [disabled]="(isDisabled$ | async) ?? true"></p-button>
  </div>
</ng-container>
<p-confirmDialog #cd header="Potvrda" width="425" appendTo="body" [key]="key"
  message="Želite li predati označene jedinice gradiva uključujući i njihove niže jedinice gradiva?">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" label="Odustani" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="Potvrdi" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>